import { useTranslation } from "react-i18next"

import { useHeaderControlsContext } from "~/components/contexts/useHeaderControlsContext"

export const useBuildBusinessPartnerSorts = () => {
  const { t } = useTranslation("suppliers")
  const { sorts, setSorts } = useHeaderControlsContext()
  return {
    sorts,
    setSorts,
    sortOptions: [
      { label: t("sort.name"), value: "name" },
      { label: t("sort.company"), value: "company" },
      {
        label: t("sort.pendingProductrequests"),
        value: "pendingProductrequests",
      },
      {
        label: t("sort.pendingTransactionCertificaterequests"),
        value: "pendingTransactionCertificaterequests",
      },
      {
        label: t("sort.pendingScopeCertificaterequests"),
        value: "pendingScopeCertificaterequests",
      },
      {
        label: t("sort.pendingProductionSiterequests"),
        value: "pendingProductionSiterequests",
      },
      {
        label: t("sort.completedProductrequests"),
        value: "completedProductrequests",
      },
      {
        label: t("sort.completedTransactionCertificaterequests"),
        value: "completedTransactionCertificaterequests",
      },
      {
        label: t("sort.completedScopeCertificaterequests"),
        value: "completedScopeCertificaterequests",
      },
      {
        label: t("sort.completedProductionSiterequests"),
        value: "completedProductionSiterequests",
      },
      { label: t("sort.email"), value: "email" },
      { label: t("sort.averageResponseTime"), value: "averageResponseTime" },
      { label: t("sort.lastConnectionDate"), value: "lastConnectionDate" },
      { label: t("sort.lastReminderDate"), value: "lastReminderDate" },
    ],
  }
}
